import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const AussieRules = () => {
  return (
    <SportsLayoutComp name={'Aussie Rules'}/>
  )
}

export default AussieRules